'use strict';

var React = require('react');
var cx = require('classnames');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","avatar-sm":"arrive_Avatar__avatar-sm","avatar-md":"arrive_Avatar__avatar-md","avatar-xl":"arrive_Avatar__avatar-xl","avatar":"arrive_Avatar__avatar","imageAvatar":"arrive_Avatar__imageAvatar","initialsAvatar":"arrive_Avatar__initialsAvatar"};

var Avatar = function Avatar(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$firstName = _ref.firstName,
      firstName = _ref$firstName === void 0 ? '' : _ref$firstName,
      _ref$lastName = _ref.lastName,
      lastName = _ref$lastName === void 0 ? '' : _ref$lastName,
      pictureUrl = _ref.pictureUrl,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.avatar, styles["avatar-".concat(size)], className, _defineProperty({}, styles.initialsAvatar, !pictureUrl))
  }, pictureUrl ? /*#__PURE__*/React__default["default"].createElement("img", {
    alt: "your-avatar",
    className: cx__default["default"](styles.imageAvatar, styles["avatar-".concat(size)]),
    src: pictureUrl
  }) : "".concat(firstName[0]).concat(lastName[0]));
};

Avatar.displayName = 'Avatar';
Avatar.propTypes = {
  className: PropTypes__default["default"].string,
  firstName: PropTypes__default["default"].string,
  lastName: PropTypes__default["default"].string,
  pictureUrl: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOf(['sm', 'md', 'xl'])
};

module.exports = Avatar;
